<template>
  <v-layout row wrap>
    <VueGallery :images="imagesBig" :index="index" @close="index = null"></VueGallery>
    <v-flex v-for="(image, i) in imagesSmall" :key="i" xs3 sm3 md3 lg3 xl3>
      <v-hover>
        <v-card
          flat
          tile
          class="d-flex"
          slot-scope="{ hover }"
          @click="index = i"
          :class="`elevation-${hover ? 12 : 2}`"
        >
          <v-img :src="image" aspect-ratio="1" class="grey lighten-2">
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-card>
      </v-hover>
    </v-flex>
  </v-layout>
</template>

<script>
import VueGallery from "vue-gallery";

export default {
  data: () => ({
    index: null,
    imagesBig: [
      "/images/antigas/05.jpg",
      "/images/antigas/07.jpg",
      "/images/antigas/01.1.jpg",
      "/images/antigas/02.jpg",
      "/images/antigas/03.1.jpg",
      "/images/antigas/06.jpg",
      "/images/antigas/08.jpg",
      "/images/antigas/11.1.jpg"
    ],
    imagesSmall: [
      "/images/antigas/05t.jpg",
      "/images/antigas/07t.jpg",
      "/images/antigas/01t.1.jpg",
      "/images/antigas/02t.jpg",
      "/images/antigas/03t.1.jpg",
      "/images/antigas/06t.jpg",
      "/images/antigas/08t.jpg",
      "/images/antigas/11t.1.jpg"
    ]
  }),
  methods: {
    abreFoto: () => {
      alert("Em desenvolvimento...");
    }
  },
  components: {
    VueGallery
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  cursor: pointer;
}
</style>
